import * as React from "react"
import { useEffect } from "react"

import {AppWrapperPage} from "../../../@componets";
import { pageTitle, pageSubtitle, pageActions, pageTitleAction } from "../../../@signals";
export default function MaximalLayoutWrapperPage({ title, subtitle, actions, titleAction, children, ...props }) {
    useEffect(() => {
        pageTitle.value = title || ''
        pageSubtitle.value = subtitle || ''
        pageActions.value = actions || null
        pageTitleAction.value = titleAction || null
        return () => {
            pageActions.value = null
            pageTitleAction.value = null
            pageSubtitle.value = ''
        }
    }, [title, subtitle, actions, titleAction])

    return <AppWrapperPage
		title={null}
		pageTitle={title}
		pageSubtitle={subtitle}
		{...props}
	>
		{children}
    </AppWrapperPage>
}